import createApp, { scope as keyApp } from "App/store";
import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

import ProjectManagementStore, {
  scope as keyProjects,
} from "features/ProjectManagement/store";

import createScriptStore, {
  scope as keyScripts,
} from "features/ScriptManagement/store";

import ParticipantManagementStore, {
  scope as keyParticipants,
} from "features/ParticipantManagement/store";

import createPlaylistManagement, {
  scope as keyPlaylists,
} from "features/PlaylistManagement/store";

import VideoManagementStore, {
  scope as keyVideo,
} from "features/VideoManagement/store";

import SelectionManagementStore, {
  scope as keySelection,
} from "features/SelectionManagement/store";

import NotificationsStore, {
  scope as keyNotification,
} from "features/Notifications/store";

import ModalManagementStore, {
  scope as keyModal,
} from "features/ModalManagement/store";

export { axios } from "utils/axiosInterceptors";
export { usePersistStore } from "./usePersistStore";
export {
  keyApp,
  keyModal,
  keyNotification,
  keyParticipants,
  keyPlaylists,
  keyProjects,
  keyScripts,
  keySelection,
  keyVideo,
};
export const useStore = create()(
  devtools(
    immer((set, get) => ({
      [keyApp]: createApp(set, get),
      [keyProjects]: ProjectManagementStore(set, get),
      [keyScripts]: createScriptStore(set, get),
      [keyParticipants]: ParticipantManagementStore(set, get),
      [keyNotification]: NotificationsStore(set, get),
      [keyVideo]: VideoManagementStore(set, get),
      [keyPlaylists]: createPlaylistManagement(set, get),
      [keySelection]: SelectionManagementStore(set, get),
      [keyModal]: ModalManagementStore(set),
    })),
  ),
);
